import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import DatasetForm from 'components/dbs/DatasetForm';
import withModalView from 'components/ui/withModalView';
import withAuthorizer from 'components/ui/withAuthorizer';

import { Resources } from 'helpers/ResourceHelper';

import DatasetApi from 'api/dataset';

const FormDatasetPage = ({ db, back, setState }) => {
  const { t } = useTranslation();
  const { datasetId } = useParams();
  const queryClient = useQueryClient();

  const mutationParams = {
    onSuccess: () => {
      queryClient.invalidateQueries('datasets');
    },
  };
  const updateMutation = useMutation(data => DatasetApi.update(datasetId, data), mutationParams);

  const fetchDataset = async () => await DatasetApi.get(datasetId);
  const { isLoading, data } = useQuery(`dataset-${datasetId}`, fetchDataset);

  if (isLoading) {
    return t('keys.loading');
  }

  const dataset = data || {};

  const $schema = db.schema || {};
  const schema = { ...$schema };
  const title = $schema.title;

  const formData = dataset.data || {};

  const onSubmit = async ({ formData }) => {
    delete formData._id;
    updateMutation.mutate(formData);

    setTimeout(async () => {
      setState(prevState => {
        return { ...prevState, changed: true };
      });
    }, 150);
  };

  return (
    <>
      <div className="container">
        <div className="mb-2">{t('actions.edit')}</div>
        <h3>{title}</h3>
      </div>

      <div className="container mt-4">
        <DatasetForm schema={schema} formData={updateMutation.data || formData} back={back} disabled={updateMutation.isLoading} onSubmit={onSubmit} />
      </div>
    </>
  );
};

export default withModalView(withAuthorizer(FormDatasetPage, [Resources.DB_MANAGER]));
